/* eslint-disable @typescript-eslint/no-explicit-any */
(window as any).__Zone_enable_cross_context_check = true;
